import type { ReactNode } from 'react'
import styled from 'styled-components'

import { theme } from '@/styles/theme'

type ExplanationItemProps = {
  mainTitle: string
  subTitle?: string
  text: ReactNode
}

export const ExplanationItem = ({
  mainTitle,
  subTitle,
  text,
}: ExplanationItemProps) => {
  return (
    <ExplanationItemStyled>
      <h4>
        {mainTitle}
        <span>{subTitle}</span>
      </h4>
      <p>{text}</p>
    </ExplanationItemStyled>
  )
}

const ExplanationItemStyled = styled.div`
  h4 {
    font-size: 25px;
    color: ${theme.colors.trialBlue};
    font-weight: bold;
    font-family: ${theme.fontEn};
    line-height: 1;
    margin-bottom: 10px;
  }

  span {
    margin-left: 16px;
    font-size: 20px;
    color: #3786c7;
    font-weight: normal;
  }

  p {
    font-size: 18px;
    line-height: 1.5;
  }

  & + & {
    margin-top: 40px;
  }

  @media screen and (max-width: 1047px) {
    h4 {
      font-size: 20px;
      margin-bottom: 8px;
    }

    span {
      font-size: 18px;
    }

    p {
      font-size: 15px;
    }

    & + & {
      margin-top: 26px;
    }
  }
`
